module.exports = __webpack_public_path__ + "media/images/ntt-research-logo-754be610c4eee22f29eb2e32cd875827.svg";